/* Sofiya Mart — AJAX filtering, sorting and pagination for collection & search pages. */
(function () {
  'use strict';
  var SM = window.SM || {};

  function Facets(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section');
    this.cache = {};
    this.bind();
  }

  Facets.prototype.form = function () { return this.root.querySelector('[data-sm-facets-form]'); };

  Facets.prototype.urlFromForm = function () {
    var form = this.form();
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (val, key) { if (val !== '' && val != null) params.append(key, val); });
    }
    var sort = this.root.querySelector('[data-sm-sort]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    var q = params.toString();
    return window.location.pathname + (q ? '?' + q : '');
  };

  Facets.prototype.render = function (url, push, scroll) {
    var self = this;
    var root = this.root;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl = url + sep + 'section_id=' + encodeURIComponent(this.sectionId);
    root.classList.add('is-loading');

    var expanded = [];
    root.querySelectorAll('[data-sm-facet]').forEach(function (f, i) { if (f.classList.contains('is-expanded')) expanded.push(i); });
    var sideScroll = root.querySelector('.sm-facets__scroll');
    var sideTop = sideScroll ? sideScroll.scrollTop : 0;
    var panelScroll = root.querySelector('.sm-facets__panel');
    var panelTop = panelScroll ? panelScroll.scrollTop : 0;

    var getHtml = this.cache[fetchUrl]
      ? Promise.resolve(this.cache[fetchUrl])
      : fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (t) { self.cache[fetchUrl] = t; return t; });

    getHtml.then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      ['[data-sm-facets-results]', '[data-sm-facets-active]', '[data-sm-facets-count]', '[data-sm-facets-total]', '[data-sm-facets-sidebar-inner]', '[data-sm-search-head]'].forEach(function (sel) {
        var fresh = doc.querySelector(sel);
        var cur = root.querySelector(sel);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
      root.querySelectorAll('[data-sm-facet]').forEach(function (f, i) { if (expanded.indexOf(i) > -1) f.classList.add('is-expanded'); });
      var ss = root.querySelector('.sm-facets__scroll'); if (ss) ss.scrollTop = sideTop;
      var ps = root.querySelector('.sm-facets__panel'); if (ps) ps.scrollTop = panelTop;
      if (push !== false) window.history.pushState({ smFacets: true }, '', url);
      if (scroll) {
        var target = root.querySelector('.sm-col-main') || root;
        var top = target.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sm-header-offset'), 10) || 120);
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
      if (SM.init) SM.init(root);
    }).catch(function () {
      window.location.href = url;
    }).finally(function () { root.classList.remove('is-loading'); });
  };

  Facets.prototype.bind = function () {
    var self = this;
    var root = this.root;
    var timer;
    var queue = function () {
      clearTimeout(timer);
      timer = setTimeout(function () { self.render(self.urlFromForm(), true, false); }, 250);
    };

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-sm-sort]') || (t.form && t.form === self.form())) queue();
    });

    root.addEventListener('submit', function (e) {
      if (e.target === self.form()) { e.preventDefault(); queue(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-sm-price-min], [data-sm-price-max]')) { e.preventDefault(); queue(); }
    });

    root.addEventListener('click', function (e) {
      var preset = e.target.closest('[data-sm-price-preset]');
      if (preset) {
        e.preventDefault();
        var fs = preset.closest('[data-sm-price]');
        var min = fs.querySelector('[data-sm-price-min]');
        var max = fs.querySelector('[data-sm-price-max]');
        var active = preset.getAttribute('aria-pressed') === 'true';
        if (min) min.value = active ? '' : (preset.getAttribute('data-min') || '');
        if (max) max.value = active ? '' : (preset.getAttribute('data-max') || '');
        fs.querySelectorAll('[data-sm-price-preset]').forEach(function (p) {
          var on = p === preset && !active;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        queue();
        return;
      }
      var link = e.target.closest('[data-sm-facet-link]');
      if (link && link.href) {
        e.preventDefault();
        var u = new URL(link.href, window.location.origin);
        var isPage = u.searchParams.has('page') || link.closest('.sm-pagination');
        self.render(u.pathname + u.search, true, !!isPage);
        return;
      }
      var more = e.target.closest('[data-sm-facet-more]');
      if (more) {
        var f = more.closest('[data-sm-facet]');
        var open = f.classList.toggle('is-expanded');
        var less = more.getAttribute('data-less');
        if (!more.getAttribute('data-more')) more.setAttribute('data-more', more.textContent);
        more.textContent = open ? less : more.getAttribute('data-more');
      }
    });

    window.addEventListener('popstate', function () {
      self.render(window.location.pathname + window.location.search, false, false);
    });
  };

  function init() {
    document.querySelectorAll('[data-sm-facets]').forEach(function (el) {
      if (!el.__smFacets) el.__smFacets = new Facets(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
